/**
 * 답례품 전용전화 (고객 안내·전화주문 유도·문자 발신번호 공통)
 * 테넌트별 배포 시 REACT_APP_GIFT_SUPPORT_PHONE 으로 교체 가능 — 미지정이면 기본값.
 * 백엔드(NCP 발신번호)도 .env 로 관리하므로 번호 변경 시 양쪽 env 를 함께 맞춘다.
 */
export const GIFT_SUPPORT_PHONE =
  process.env.REACT_APP_GIFT_SUPPORT_PHONE || '1533-1429';

/** tel: 링크용 (숫자만) */
export const GIFT_SUPPORT_PHONE_TEL = GIFT_SUPPORT_PHONE.replace(/\D/g, '');
